import { render } from "./tw-switch.vue?vue&type=template&id=0897a9a6"
import script from "./tw-switch.vue?vue&type=script&lang=js"
export * from "./tw-switch.vue?vue&type=script&lang=js"
script.render = render

export default script